import { EmailTextPhrases } from "../components/admin/create/scheduled-emails/event-emails";

// HELPERS
const convertDate = (timestamp: number | null) => {
	function pad(i: number) {
		return i.toString().padStart(2, '0');
	}

	if (timestamp) {
		// format the time stamp correctly
		const event = new Date(timestamp);
		const year = event.getUTCFullYear();
		const month = pad(event.getUTCMonth() + 1);
		const day = pad(event.getUTCDate());
		const hour = pad(event.getUTCHours());
		const minute = pad(event.getUTCMinutes());
		const second = pad(event.getUTCSeconds());
		return `${year}${month}${day}T${hour}${minute}${second}Z`;
	}
};

// we have two unique variables for ics and google because links and linebreaks are handled differently between the two
const getDescription = (type: 'ics' | 'google', description: string, url: string, translations: EmailTextPhrases): string => {
	const joinWithColon = translations.ClickHereToJoinColon || 'Click here to join:';
	const joinWithPeriod = translations.ClickHereToJoinPeriod || 'Click here to join.';
	// return the description with a link
	return type === 'ics' ?
		description + '\\n\\n' + joinWithColon + '\\n' + url : //ics format
		description + '\n\n' + `<a href="${url}">${joinWithPeriod}</a>`; //google format
};


// PRIMARY FUNCTIONS
export const icsFile = (start: number | null, end: number | null, name: string, description: string, url: string, uuid: string, translations: EmailTextPhrases): File | null => {
	if (!start || !end) return null;

	const sessionStart = convertDate(start);
	const sessionEnd = convertDate(end);
	const icsDescription = getDescription('ics', description, url, translations);

	const icsFileText =
		'BEGIN:VCALENDAR\n' +
		'PRODID:-//Brandlive//NONSGML HandCal//EN\n' +
		'VERSION:2.0\n' +
		'BEGIN:VEVENT\n' +
		'UID:' + uuid + '\n' +
		'DTSTART:' + sessionStart + '\n' +
		'DTEND:' + sessionEnd + '\n' +
		'SUMMARY:' + name + '\n' +
		'DESCRIPTION:' + icsDescription + '\n' +
		'LOCATION:' + url + '\n' +
		'END:VEVENT\n' +
		'END:VCALENDAR';

	const fileName = `${name.replace(/[^0-9a-zA-Z]/g, '-')}-calendar-invite.ics`;
	return new File([icsFileText], fileName, { type: 'text/calendar' });
};

export const googleCalendarLink = (start: number | null, end: number | null, name: string, description: string, url: string, translations: EmailTextPhrases): string => {
	if (!start || !end) return '';

	const sessionStart = convertDate(start);
	const sessionEnd = convertDate(end);
	const titleAsUrl = encodeURIComponent(name);
	const descriptionAsUrl = encodeURIComponent(getDescription('google', description, url, translations));

	const googleQuery = `${sessionStart}/${sessionEnd}&text=${titleAsUrl}&details=${descriptionAsUrl}&location=${url}`;
	return `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${googleQuery}`;
};